import React from "react";
import {Route, Switch} from "react-router";
import MessagesPage from "./MessagesPage";
import InstancesPage from "./InstancesPage";
import InstancesSeriesWhatsappPage from "./InstancesSeriesWhatsappPage";
import InstancesSeriesTelegramPage from "./InstancesSeriesTelegramPage";
import InstancesSeriesMaxPage from "./InstancesSeriesMaxPage";
import InstancesServiceWhatsappPage from "./InstancesServiceWhatsappPage";
import InstancesServiceTelegramPage from "./InstancesServiceTelegramPage";
import InstancesServiceMaxPage from "./InstancesServiceMaxPage";
import InstancesServiceMaxPaymentLinkPage from "./InstancesServiceMaxPaymentLinkPage";
import SendMessagePage from "./SendMessagePage";
import WebhookHistoryPage from "./WebhookHistoryPage";

export const navLinks = [
    {path: "/green-api", text: "Messages"},
    {path: "/green-api/instances", text: "Instances for processes"},
    {group: "Series instances", path: "/green-api/instances/series/whatsapp", text: "WhatsApp"},
    {group: "Series instances", path: "/green-api/instances/series/telegram", text: "Telegram"},
    {group: "Series instances", path: "/green-api/instances/series/max", text: "Max"},
    {group: "Service instances", path: "/green-api/instances/service/whatsapp", text: "WhatsApp"},
    {group: "Service instances", path: "/green-api/instances/service/telegram", text: "Telegram"},
    {group: "Service instances", path: "/green-api/instances/service/max", text: "Max"},
    {group: "Service instances", path: "/green-api/instances/service/max-payment-link", text: "Max payment link"},
    {path: "/green-api/send-message", text: "Send messages"},
    {path: "/green-api/webhook-history", text: "Webhook History"},
]

export default function GreenApiPage() {
    return (
        <>
            <Switch>
                <Route exact path="/green-api" component={MessagesPage}/>
                <Route exact path="/green-api/instances" component={InstancesPage}/>
                <Route exact path="/green-api/instances/series/whatsapp" component={InstancesSeriesWhatsappPage}/>
                <Route exact path="/green-api/instances/series/telegram" component={InstancesSeriesTelegramPage}/>
                <Route exact path="/green-api/instances/series/max" component={InstancesSeriesMaxPage}/>
                <Route exact path="/green-api/instances/service/whatsapp" component={InstancesServiceWhatsappPage}/>
                <Route exact path="/green-api/instances/service/telegram" component={InstancesServiceTelegramPage}/>
                <Route exact path="/green-api/instances/service/max" component={InstancesServiceMaxPage}/>
                <Route exact path="/green-api/instances/service/max-payment-link" component={InstancesServiceMaxPaymentLinkPage}/>
                <Route path="/green-api/send-message" component={SendMessagePage}/>
                <Route path="/green-api/webhook-history" component={WebhookHistoryPage}/>
            </Switch>
        </>
    )
}
